import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MergePurgeParameters } from './types/merge-purge-parameters.type';
import type { SuppressionDetail } from './types/suppression-detail.type';

/**
 * Retrieves suppression details for a merge-purge operation.
 *
 * @param instance - The Ky HTTP client instance to use for the request.
 * @param searchParams - Parameters for the merge-purge operation used to filter suppression details.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link SuppressionDetail}.
 * @throws Will throw an error if the request fails.
 */
export const getSuppressionDetails = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<SuppressionDetail[]>>(Uri.reports.mergePurge.suppressionDetails, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
